// extracted by mini-css-extract-plugin
export default {"logo":"MainNav_logo__np7UF","icons":"MainNav_icons__VAqxM","dark-bg":"MainNav_dark-bg__pdR+W"};